/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import './MobileMenu.css';

function MobileMenu(props) {
  return (
    <div className="genesee mobile-menu">
      <a href="#" onClick={props.onMenuClose} className="close-menu">
        <i className="fa fa-times-thin" />
        {' '}
        Close
      </a>
      <ul>
        <li className="list-cell">
          <a href="https://geneseesci.com/">HOME</a>
        </li>
        <li className="list-cell">
          <a href="https://geneseesci.com/">Browsing History</a>
        </li>
        <li className="list-cell">
          <a href="https://geneseesci.com/">By Product</a>
        </li>
        <li className="list-cell">
          <a href="https://geneseesci.com/">By Application</a>
        </li>
        <li className="list-cell">
          <a href="https://geneseesci.com/">A to Z Product List</a>
        </li>
        <li className="list-cell">
          <a href="https://geneseesci.com/support">Support</a>
        </li>
        <li className="list-cell">
          <a href="https://geneseesci.com/company/about-us">Company</a>
        </li>
        <li className="list-cell">
          <a href="https://geneseesci.com/contact">Contact</a>
        </li>
      </ul>
    </div>
  );
}

export default MobileMenu;
